export function promise() {
  throw new Error("Not implemented");
}
